<template>
  <div class="func-panel">
    <div class="func-item" @click="upload">
      <img src="@/assets/images/tupianshangchuan.png" class="func-icon-img" alt="图片上传" />
      <span class="func-label">图片上传</span>
    </div>
    <div class="func-item" @click="hint">
      <img src="@/assets/images/huoqutishi.png" class="func-icon-img" alt="获取提示" />
      <span class="func-label">获取提示</span>
    </div>
    <div class="func-item" @click="restart">
      <img src="@/assets/images/chongxinkaishi.png" class="func-icon-img" alt="重新开始" />
      <span class="func-label">重新开始</span>
    </div>
    <div class="func-item" @click="goBack">
      <img src="@/assets/images/shangyibu.png" class="func-icon-img" alt="返回上一步" />
      <span class="func-label">返回上一步</span>
    </div>
    <div class="func-item" @click="orders">
      <img src="@/assets/images/lishidingdan.png" class="func-icon-img" alt="历史订单" />
      <span class="func-label">查看订单</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FuncPanel',
  methods: {
    upload() {
      this.$emit('upload');
    },
    hint() {
      this.$emit('hint');
    },
    restart() {
      this.$emit('restart');
    },
    goBack() {
      this.$emit('goback');
    },
    orders() {
      this.$emit('orders');
    },
  },
};
</script>

<style lang="scss" scoped>
.func-panel {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  padding: 12px;
  background: #f9f9f9;
  border-top: 1px solid #eee;
}
.func-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
  border-radius: 8px;
  background: #fff;
}
.func-icon-img {
  width: 28px;
  height: 28px;
  margin-bottom: 6px;
  object-fit: contain;
}
.func-label {
  font-size: 12px;
  color: #666;
}
</style>
